import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=24f0f565"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3833976396/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24f0f565')) {
      api.createRecord('24f0f565', component.options)
    } else {
      api.reload('24f0f565', component.options)
    }
    module.hot.accept("./TermsAndConditionsModal.vue?vue&type=template&id=24f0f565", function () {
      api.rerender('24f0f565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TermsAndConditionsModal.vue"
export default component.exports